if (!customElements.get('product-mobile-gallery')) {
  class ProductMobileGallery extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute('id');
      this.mainSwiper = null;
      this.isInitialized = false;
      this.handleGalleryClick = this.handleGalleryClick.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize());
      } else {
        if (typeof Swiper !== 'undefined') {
          this.initialize();
        } else {
          setTimeout(() => {
            if (typeof Swiper !== 'undefined') {
              this.initialize();
            } else {
              console.warn('Swiper not found. Make sure swiper-bundle.min.js is loaded.');
            }
          }, 500);
        }
      }
    }

    initialize() {
      this.cleanupSwipers();
      this.initMainSwiper();
      this.addEventListeners();

      this.isInitialized = true;

      this.dispatchEvent(new CustomEvent('gallery:initialized', {
        bubbles: true,
        detail: { gallery: this }
      }));
    }

    cleanupSwipers() {
      if (this.mainSwiper) {
        if (!this.mainSwiper.destroyed) {
          this.mainSwiper.destroy(true, true);
        }
        this.mainSwiper = null;
      }
    }

    initMainSwiper() {
      const mainSwiperContainer = this.querySelector('.product__media-mobile');
      if (!mainSwiperContainer) return;

      this.mainSwiper = new Swiper(mainSwiperContainer, {
        slidesPerView: 1.20,
        spaceBetween: 6,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: `#${this.id} .product__media-mobile-pagination`,
          type: 'bullets',
          clickable: true,
        }
      });
    }

    addEventListeners() {
      const mainGalleryWrapper = this.querySelector('.product__media-mobile-swiper-wrapper');
      if (mainGalleryWrapper) {
        mainGalleryWrapper.addEventListener('click', this.handleGalleryClick);
      }
    }

    handleGalleryClick(event) {
      if (window.innerWidth > 1099) return;
      
      const clickedSlide = event.target.closest('.swiper-slide');
      if (!clickedSlide) return;
      
      let slideIndex = 0;
      
      if (this.mainSwiper) {
        const slideIndexAttr = clickedSlide.getAttribute('data-swiper-slide-index');
        if (slideIndexAttr !== null) {
          slideIndex = parseInt(slideIndexAttr, 10);
        } else {
          const allSlides = Array.from(this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
          slideIndex = allSlides.indexOf(clickedSlide);
          if (slideIndex === -1) {
            slideIndex = this.mainSwiper.realIndex || 0;
          }
        }
      }
      
      if (typeof window.openProductMediaModal === 'function') {
        window.openProductMediaModal(slideIndex);
      }
    }

    openModal(slideIndex = 0) {
      if (typeof window.openProductMediaModal === 'function') {
        window.openProductMediaModal(slideIndex);
      }
    }

    disconnectedCallback() {
      const mainGalleryWrapper = this.querySelector('.product__media-mobile-swiper-wrapper');
      if (mainGalleryWrapper) {
        mainGalleryWrapper.removeEventListener('click', this.handleGalleryClick);
      }

      this.cleanupSwipers();
    }
  }

  customElements.define('product-mobile-gallery', ProductMobileGallery);
}